import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckWorkspaceMenuFilled = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	height: 10,
	viewBox: "0 0 14 10",
	width: 14,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m4.9375 9.71398-4.125-4.125 1.17833-1.17833 2.94792 2.94458-.00125.00125 7.0708-7.070835 1.1784 1.178335-7.07087 7.07166-1.1775 1.1775z",
		fill: "#005ce6"
	})
});
export { SvgCheckWorkspaceMenuFilled as ReactComponent };
